import { IFilterList } from "../../utils/interfaces/FilterListInterface";
import { toPartialQueryString } from "../../utils/parsers/QueryString";
import { SellerTypeListEnum } from "../enums/SellerTypeListEnum";
import { SellerModel } from "./SellerModel";

interface SellerTypeListWrapped {
    enum: SellerTypeListEnum,
    description: string,
}

export class SellerListFilterFormModel implements IFilterList {
    static getSellerTypeList():SellerTypeListWrapped[] {
        return [
            {
                enum: SellerTypeListEnum.Alterdata,
                description: "Alterdata",
            },
            {
                enum: SellerTypeListEnum.Representacao,
                description: "Representação",
            },
            {
                enum: SellerTypeListEnum.Vendedor,
                description: "Vendedor",
            },
        ]
    }

    name: string = ""
    email: string = ""
    publicKey: string = ""
    idExternal: string = ""
    parent: SellerModel
    typeList: SellerTypeListWrapped[] = [
        {
            enum: SellerTypeListEnum.Alterdata, 
            description: "Alterdata",
        },
        {
            enum: SellerTypeListEnum.Representacao,
            description: "Representação",
        }
    ]

    isFilterFilled():boolean {
        return !!this.name ||
            !!this.email ||
            !!this.publicKey ||
            !!this.idExternal ||
            (!!this.parent && !!this.parent.id) ||
            (Array.isArray(this.typeList) && !!this.typeList.length)
    }

    toPartialQueryString():string {
        const tmp = {
            ...this,
            idParent: !!this.parent ? this.parent.id : undefined,
            typeList: this.typeList.length ? this.typeList.map((t) => t.enum).join(',') : undefined,
        }

        return toPartialQueryString(tmp)
    }
}
